// eslint-disable-next-line max-len
export const fatZebraIdenPt = String(
  import.meta.env.VITE_FAT_ZEBRA_CARD_TOKEN_DECRYPTION_PRIVATE_KEY
);
